import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, HeartIcon, StethoscopeIcon, ArrowRightIcon, ShieldIcon, LeafIcon, HandHeart } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
const PAYPAL_PLAN_ID = 'P-59L209474F688330RNJUPQWQ';
const PAYPAL_CLIENT_ID = 'BAA1DW7ZBvK2LgAEXUXSNK4NYwgrgHdcNnswgPsRAFxuyniLkW3bjyHCo2zyWPdqtNC_gNl_Y12oz-5spc';
const features = ['Pago 100% seguro', 'Recibo inmediato por email', 'Puedes elegir el monto'];
function FeatureItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-2" data-id="element-284" data-mp="220jossv5drn9">
      <span style={{
      color: '#7DC920',
      fontWeight: 700
    }} data-id="element-285" data-mp="21zgzuqhdxz9z">
        ✓
      </span>
      <span data-id="element-286" data-mp="1x04c83iowo6c">{text}</span>
    </li>;
}
const impactItems = [{
  icon: BookOpenIcon,
  title: 'Educación',
  text: 'Recursos y guías para familias'
}, {
  icon: HeartIcon,
  title: 'Nutrición',
  text: 'Planes antiinflamatorios'
}, {
  icon: StethoscopeIcon,
  title: 'Especialistas',
  text: 'Acceso a medicina biomédica'
}, {
  icon: HandHeart,
  title: 'Familias en crisis',
  text: 'Artículos de primera necesidad para familias afectadas por emergencias aprobadas por la junta directiva'
}];
export function Donar() {
  const [donationType, setDonationType] = useState<'unica' | 'mensual'>('unica');
  useEffect(() => {
    if (donationType !== 'mensual') return;
    const containerId = `paypal-button-container-${PAYPAL_PLAN_ID}`;
    const timer = window.setTimeout(() => {
      document.getElementById('paypal-monthly-sdk')?.remove();
      const container = document.getElementById(containerId);
      if (container) container.innerHTML = '';
      const script = document.createElement('script');
      script.id = 'paypal-monthly-sdk';
      script.src = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&vault=true&intent=subscription`;
      script.setAttribute('data-sdk-integration-source', 'button-factory');
      script.onload = () => {
        const paypal = (window as unknown as {
          paypal?: any;
        }).paypal;
        if (!paypal) return;
        paypal.Buttons({
          style: {
            shape: 'rect',
            color: 'gold',
            layout: 'horizontal',
            label: 'subscribe'
          },
          createSubscription: (_data: unknown, actions: any) => actions.subscription.create({
            plan_id: PAYPAL_PLAN_ID
          }),
          onApprove: (data: {
            subscriptionID: string;
          }) => {
            window.alert(`Suscripción activada. ID: ${data.subscriptionID}`);
          }
        }).render(`#${containerId}`);
      };
      document.body.appendChild(script);
    }, 100);
    return () => window.clearTimeout(timer);
  }, [donationType]);
  useDocumentMeta({
    title: 'Donar | Pancita Feliz Foundation',
    description: 'Tu donación transforma vidas. Apoya a Pancita Feliz Foundation y ayuda a familias con necesidades de neurodesarrollo.',
    path: '/donar'
  });
  return <main className="w-full" data-id="element-287" data-mp="1dvld3q4ba6u3">
      {/* Hero */}
      <section className="text-center" style={{
      background: 'linear-gradient(135deg, #1a3a0a 0%, #2d5a1b 100%)',
      padding: '80px 20px 60px',
      color: 'white'
    }} data-id="element-288" data-mp="1itv9g41rvdha">
        <img src="https://cdn.magicpatterns.com/uploads/wpdp43pGEjSRNDR3FLVv4Q/pancita_feliz.png" alt="Pancita Feliz Foundation" className="mp-donar-hero-logo" style={{
        height: 'auto',
        objectFit: 'contain',
        display: 'block',
        margin: '0 auto 32px auto',
        filter: 'brightness(0) invert(1)'
      }} data-id="element-289" data-mp="1srj30qnn6exv" />
        <p style={{
        fontSize: '13px',
        color: '#a8e063',
        letterSpacing: '3px',
        fontWeight: 600,
        textTransform: 'uppercase',
        marginBottom: '12px'
      }} data-id="element-290" data-mp="2bkn2wtrgdo0x">
          Tu Donación Transforma Vidas
        </p>
        <h1 className="mp-donar-title" style={{
        fontWeight: 700,
        color: 'white',
        marginBottom: '16px'
      }} data-id="element-291" data-mp="389xlrm2xpfif">
          Sé Parte del Cambio
        </h1>
        <p style={{
        fontSize: '18px',
        color: 'rgba(255,255,255,0.85)',
        maxWidth: '580px',
        margin: '0 auto 40px'
      }} data-id="element-292" data-mp="3i2d1ecqrds05">
          Cada donación permite que una familia acceda a educación, nutrición y
          medicina biomédica que transforma el neurodesarrollo de sus hijos.
        </p>
      </section>

      {/* Donation cards */}
      <section className="mp-donar-body" style={{
      background: '#f8faf5',
      padding: '60px 20px'
    }} data-id="element-293" data-mp="2zc52k6u3dnpr">
        <div role="group" aria-label="Tipo de donación" style={{
        display: 'flex',
        background: '#f0f0f0',
        borderRadius: '30px',
        padding: '4px',
        width: 'fit-content',
        margin: '0 auto 32px'
      }} data-id="element-294" data-mp="eirwx2fbvtm1">
          {([{
          key: 'unica',
          label: 'Donación única'
        }, {
          key: 'mensual',
          label: 'Donación mensual'
        }] as const).map(({
          key,
          label
        }) => <button key={key} type="button" onClick={() => setDonationType(key)} aria-pressed={donationType === key} style={{
          background: donationType === key ? '#2d5a1b' : 'transparent',
          color: donationType === key ? 'white' : '#666',
          borderRadius: '26px',
          padding: '10px 24px',
          fontWeight: donationType === key ? 600 : 400,
          fontSize: '14px',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-295" data-mp="19s3xzanu6w96">
              {label}
            </button>)}
        </div>
        {donationType === 'mensual' && <p style={{
        fontSize: '12px',
        color: '#888',
        textAlign: 'center',
        marginTop: '-20px',
        marginBottom: '24px'
      }} data-id="element-296" data-mp="1tgjjoiaoaevi">
            Tu donación mensual se procesa de forma segura y automática. Puedes
            cancelar en cualquier momento.
          </p>}
        <div className="mp-donar-cards" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px',
        maxWidth: '700px',
        margin: '0 auto'
      }} data-id="element-297" data-mp="19qzdlflyzkr6">
          {/* Card 1: Stripe */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #635BFF',
          textAlign: 'center'
        }} data-id="element-298" data-mp="vrpyykdewypb">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #635BFF 0%, #8B7FFF 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(99,91,255,0.35)'
          }} data-id="element-299" data-mp="3hdizhoxrtdxd">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg" alt="Stripe" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-300" data-mp="32f737jeb876q" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-301" data-mp="ycqthgj0jt6k">
              Donar con Tarjeta
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-302" data-mp="18chpxnr4wi9a">
              Visa, Mastercard, American Express
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-303" data-mp="1vzprpvpct96k">
              <FeatureItem text="Pago 100% seguro" data-id="element-304" data-mp="2517699n452t5" />
              <FeatureItem text="Procesado por Stripe" data-id="element-305" data-mp="20zc4y556mpfd" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-306" data-mp="210x282ivsmgx" />
              <FeatureItem text="Puedes elegir el monto" data-id="element-307" data-mp="2jofogueua8em" />
            </ul>
            <a href={donationType === 'mensual' ? 'https://donate.stripe.com/3cI00j5XRdfJ2z9efU00002' : 'https://buy.stripe.com/cNicN585Zb7B3Dd6Ns00000'} target="_blank" rel="noopener noreferrer" className="mp-stripe-btn mp-donar-btn flex items-center justify-center gap-2" style={{
            background: '#635BFF',
            color: 'white',
            width: '100%',
            height: '52px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none'
          }} data-id="element-308" data-mp="2om7efivxbkg6">
              Donar con Tarjeta
              <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-309" data-mp="1mw2em9df11g1" />
            </a>
          </div>

          {/* Card 2: PayPal */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #009cde',
          textAlign: 'center'
        }} data-id="element-310" data-mp="1lbj9bsn34rug">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #009cde 0%, #003087 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(0,156,222,0.35)'
          }} data-id="element-311" data-mp="1gc6otejorwv1">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-312" data-mp="2mx7mi4u43xg7" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-313" data-mp="p33h0odymkss">
              Donar con PayPal
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-314" data-mp="3tiwjhjp3tn3b">
              Saldo PayPal o tarjeta vinculada
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-315" data-mp="1cr93dipso27">
              <FeatureItem text="Pago 100% seguro" data-id="element-316" data-mp="1cs68sp2b5u10" />
              <FeatureItem text="Procesado por PayPal" data-id="element-317" data-mp="afjisn5z8b2p" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-318" data-mp="ah49u2t31bvt" />
              <FeatureItem text="Puedes elegir el monto" data-id="element-319" data-mp="fcrzskfe292d" />
            </ul>
            {donationType === 'mensual' ? <>
                <div id={`paypal-button-container-${PAYPAL_PLAN_ID}`} style={{
              width: '100%',
              minHeight: '50px',
              marginTop: '16px'
            }} data-id="element-320" data-mp="jdvfn6xfs53l" />
                <p style={{
              fontSize: '12px',
              color: '#888',
              textAlign: 'center',
              marginTop: '8px'
            }} data-id="element-321" data-mp="3rw1azq28bath">
                  Suscripción mensual segura procesada por PayPal. Puedes
                  cancelar cuando quieras.
                </p>
              </> : <a href="https://www.paypal.com/ncp/payment/7MR2476FEM7HC" target="_blank" rel="noopener noreferrer" className="mp-paypal-btn mp-donar-btn flex items-center justify-center gap-2" style={{
            background: '#009cde',
            color: 'white',
            width: '100%',
            height: '52px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none'
          }} data-id="element-322" data-mp="393ffx7z5bo9y">
                Donar con PayPal
                <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-323" data-mp="28ur0l3du0mvu" />
              </a>}
          </div>
        </div>

        {/* Trust section */}
        <div style={{
        marginTop: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        flexWrap: 'wrap'
      }} data-id="element-324" data-mp="1zv3ysgh6xf29">
          {[{
          icon: ShieldIcon,
          label: 'Pagos 100% seguros'
        }, {
          icon: LeafIcon,
          label: 'Fundación 501(c)(3) registrada — tu donación es deducible de impuestos'
        }, {
          icon: HeartIcon,
          label: 'Tu donación hace la diferencia'
        }].map(({
          icon: Icon,
          label
        }) => <span key={label} style={{
          fontSize: '13px',
          color: '#555',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }} data-id="element-325" data-mp="3gbgu9v1b4zsy">
              <Icon size={16} color="#7DC920" data-id="element-326" data-mp="10izxzjpnzk21" />
              {label}
            </span>)}
        </div>

        {/* Impact section */}
        <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '700px',
        margin: '40px auto 0',
        padding: '32px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)'
      }} data-id="element-327" data-mp="15g9xjs6rpc3l">
          <h3 style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#1a1a1a',
          textAlign: 'center',
          marginBottom: '24px'
        }} data-id="element-328" data-mp="1ofehw9i006v5">
            ¿A dónde va tu donación?
          </h3>
          <div className="mp-donar-impact" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '20px',
          textAlign: 'center'
        }} data-id="element-329" data-mp="1tehfj8vnfat3">
            {impactItems.map(({
            icon: Icon,
            title,
            text
          }) => <div key={title} className="flex flex-col items-center" data-id="element-330" data-mp="d07pmabrde05">
                <Icon size={32} color="#7DC920" data-id="element-331" data-mp="8ycr1dl7peq2" />
                <p style={{
              fontSize: '15px',
              fontWeight: 600,
              color: '#1a1a1a',
              margin: '8px 0 4px'
            }} data-id="element-332" data-mp="8znu1b6u2ig4">
                  {title}
                </p>
                <p style={{
              fontSize: '13px',
              color: '#666'
            }} data-id="element-333" data-mp="2hz7fak6l6a3z">
                  {text}
                </p>
              </div>)}
          </div>
          <Link to="/#como-funciona" style={{
          color: '#7DC920',
          fontSize: '14px',
          fontWeight: 600,
          textAlign: 'center',
          display: 'block',
          marginTop: '24px',
          textDecoration: 'none'
        }} data-id="element-334" data-mp="2w0a3b2h55uhj">
            ¿Quieres saber exactamente cómo se procesa tu donación? Conoce el
            proceso →
          </Link>
        </div>
      </section>
    </main>;
}